import React, { useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG, SimpleAlert } from '../../../../rbts/helpers';

type Props = {
  show: boolean;
  titulo: string;
  mensaje: string;
  handleClose: (updated: boolean) => void;
  onConfirm: () => Promise<void>;
};

const RemoveModal: React.FC<Props> = ({ show, titulo, mensaje, handleClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [statusError, setStatusError] = useState('');

  const confirmRemove = async () => {
    setLoading(true);
    setStatusError('');
    try {
      await onConfirm();
      SimpleAlert('Registro eliminado correctamente', 3000, 'success');
      handleClose(true);
    } catch (err: any) {
      const msg =
        err?.response?.data?.message || 'Ocurrió un error al eliminar el registro.';
      const detail = err?.response?.data?.details?.[0]?.message;
      if (detail) setStatusError(detail);
      SimpleAlert(msg, 3000, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      id="kt_modal_remove_pv"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-500px"
      show={show}
      onHide={() => handleClose(false)}
    >
      <div className="modal-content">
        <div className="modal-header" id="kt_modal_remove_pv_header">
          <h2>{titulo}</h2>
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            onClick={() => handleClose(false)}
          >
            <KTSVG className="svg-icon-2" path="/media/icons/duotune/arrows/arr061.svg" />
          </div>
        </div>
        <div className="modal-body">
          {statusError && (
            <div className="alert alert-danger">
              <div className="alert-text font-weight-bold">{statusError}</div>
            </div>
          )}
          <div className="modal-body">
            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6">
              <KTSVG
                path="/media/icons/duotune/general/gen044.svg"
                className="svg-icon-2tx svg-icon-warning me-4 mt-7"
              />
              <div className="d-flex flex-stack flex-grow-1">
                <div className="fw-bold">
                  <div className="fs-6 text-gray-600">{mensaje}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center pt-8">
            <button
              type="reset"
              className="btn btn-light me-3"
              onClick={() => handleClose(false)}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-danger"
              disabled={loading}
              onClick={confirmRemove}
            >
              {!loading && <span className="indicator-label">Confirmar</span>}
              {loading && (
                <span className="indicator-progress" style={{ display: 'block' }}>
                  Espere por favor...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export { RemoveModal };
